import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useRouteMatch } from "react-router-dom";

import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import { Box, Hidden } from "@material-ui/core";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";

// 🔥 Firebase imports
import firebase from "firebase";
import { secondaryDb } from "../../../../utils/firebase/temp";
import {
  fetchAlertAvailabilityInfo,
  fetchAlertConfigInfo,
} from "../../../../services/insightApp/metrics";
import AlertConfigNode from "./AlertConfigNode";

type AlertItem = {
  id: string;
  label: string;
};

type AlertConfigInfo = {
  [key: string]: {
    configDetails: {
      alertName: string;
    };
  };
};

/**
 * AvailabilityPage Component
 *
 * This component fetches and displays real-time metrics from Firebase
 * based on the selected locationId and updates automatically on DB changes.
 */
const AvailabilityPage: React.FunctionComponent<{}> = () => {
  const [error, setError] = useState("");

  const [alertConfigInfo, setAlertConfigInfo] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);
  const [availabilityList, setAvailabilityList] = useState<any>([]);
  const [clientId, setClientId] = useState("");

  const match: any = useRouteMatch();
  const locationId = match?.params?.locationId;

  const handleAlertConfigInfoStructure = (
    alertConfigInfo: AlertConfigInfo,
  ): AlertItem[] => {
    if (!alertConfigInfo || Object.keys(alertConfigInfo).length === 0) {
      return [{ id: "No Alert", label: "No Alert" }];
    }

    return Object.entries(alertConfigInfo).map(([key, value]) => ({
      id: key,
      label: value.configDetails.alertName,
    }));
  };

  const getAlertAvailabilityInfo = async () => {
    try {
      const res = await fetchAlertAvailabilityInfo(locationId);
      setAvailabilityList({
        weekly: res.data.data,
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError("Please try again later.");
    }
  };

  const getAlertConfigInfo = async () => {
    try {
      const res = await fetchAlertConfigInfo(locationId);
      const alertConfigInfoStructure = handleAlertConfigInfoStructure(
        res.data.data,
      );
      setAlertConfigInfo(alertConfigInfoStructure);
      getAlertAvailabilityInfo();
    } catch (error) {
      setIsLoading(false);
      setError("Please try again later.");
    }
  };

  useEffect(() => {
    document.title = "Insight - Availability";
    getAlertConfigInfo();
  }, [locationId]);

  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box style={{ marginTop: "18px" }}>
        <AlertConfigNode
          isLoading={isLoading}
          alertConfigInfo={alertConfigInfo}
          availabilityList={availabilityList}
          getAlertAvailabilityInfo={getAlertAvailabilityInfo}
        />
      </Box>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default withAuthority(AvailabilityPage, Authorities.CUSTOMER_LIST_READ);
